/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IPdfGenerationConfigurationScope extends angular.IScope {
        model: models.PdfGenerationConfigurationModel
    }

    export class PdfGenerationConfigurationController implements IController {

        constructor(
            private scope: IPdfGenerationConfigurationScope,
            $routeParams: angular.route.IRouteParamsService,
            $route: angular.route.IRouteService,
            pdfBindingService: services.PdfBindingService,
            boundItemService: services.BoundItemService,
            processConfigurationService: services.ProcessConfigurationService,
            treeService: services.TreeService,
            deleteService: services.DeleteService)
        {
            var processConfigurationId = $routeParams["id"];

            this.scope.model = new models.PdfGenerationConfigurationModel(
                scope,
                $route,
                processConfigurationId,
                pdfBindingService,
                boundItemService,
                processConfigurationService,
                treeService,
                deleteService);

            var resizeId;
            var self = this;
            var resizeFunc = $(window).resize(() => {
                clearTimeout(resizeId);
                resizeId = setTimeout(() => {self.scope.model.reloadPage(); }, 500);
            });

            
            var listenerCallback = scope.$on('$locationChangeStart', function (event) {
                resizeFunc = null;
            });

            scope.$on("$destroy", () => {
                listenerCallback();
            });

        }
    }
}

warsApp.registerController('PdfGenerationConfigurationController', ['$scope', "$routeParams", "$route", 'pdfBindingService', 'boundItemService', 'processConfigurationService', 'treeService', 'deleteService']);